import { type FC, type ReactNode } from 'react';
import classnames from 'classnames';
import dibsCss from 'dibs-css';

export const PdpSharedBorderContainer: FC<{
    children: ReactNode;
    className?: string;
}> = ({ children, className }) => {
    return (
        <div
            className={classnames(
                className,
                dibsCss.border,
                dibsCss.borderSolid,
                dibsCss.borderDolphin,
                dibsCss.roundedXxsmall
            )}
        >
            {children}
        </div>
    );
};

export const PdpSharedBorderContainerDivider: FC<{
    className?: string;
}> = ({ className }) => {
    return (
        <div
            className={classnames(
                className,
                dibsCss.h1px,
                dibsCss.bgDolphin,
                dibsCss.wAuto,
                dibsCss.mxSmaller
            )}
        />
    );
};
